
import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { getSelectOptions } from "utils/optionHelper";
import PropTypes from "prop-types";
import FormNumberInput from "Common/Custom/FormNumberInput";


const AddPFTLForm = ({
  values = {},
  errors = {},
  handleChange = () => { },
  handleSubmit = () => { },
  loading = false,
  FoodTypesOptions = [],
  FoodPackageOptions = [],
  fields = {}
}) => {

  const optionConfig = {
    food_type_id: {
      list: FoodTypesOptions,
      valueKey: "id",
      labelKey: "name"
    },
    package_id: {
      list: FoodPackageOptions,
      valueKey: "id",
      labelKey: "name"
    }
  };

  return (
    <PageBody onSubmit={handleSubmit} headerchildren={
      <HeadingOne>Create Pakage Food Type Limit</HeadingOne>
    }>
      {fields?.map((field) => {

        if (field.type === "select") {
          return (
            <FormSelect
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              options={getSelectOptions(field.name, optionConfig)}
              error={errors[field.name]}
            />
          );
        }

        if (field.type === "Number") {
          return (
            <FormNumberInput
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              error={errors[field.name]}
            />
          );
        }

        // default text input
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );

      })}

      <FormSubmitButton
        label="Create"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

AddPFTLForm.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
  FoodTypesOptions: PropTypes.array,
  FoodPackageOptions: PropTypes.array,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    })
  )
};

AddPFTLForm.defaultProps = {
  values: {},
  errors: {},
  handleChange: () => { },
  handleSubmit: () => { },
  loading: false,
  FoodTypesOptions: [],
  FoodPackageOptions: [],
  fields: []
};

export default AddPFTLForm;
